import React from "react";
import { FaCheckCircle, FaShieldAlt, FaLock, FaArrowRight } from "react-icons/fa";
import { ImCheckmark } from "react-icons/im";
import { useNavigate } from "react-router-dom";

function PasswordCorrect() {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/homedashboard");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary100 via-blue-500 to-purple-600 flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header Section */}
        <div className="bg-gradient-to-r from-primary100 to-blue-600 px-8 py-12 text-center">
          <div className="relative">
            <div className="w-24 h-24 bg-white rounded-full flex justify-center items-center mx-auto mb-4 shadow-lg">
              <FaCheckCircle className="text-green-500 text-3xl animate-bounce" />
            </div>
            {/* Animated rings */}
            <div className="absolute inset-0 flex justify-center items-center">
              <div className="w-32 h-32 border-2 border-white/30 rounded-full animate-ping"></div>
            </div>
            {/* Celebration particles */}
            <div className="absolute inset-0 flex justify-center items-center">
              <div className="w-2 h-2 bg-yellow-300 rounded-full animate-ping" style={{animationDelay: '0.5s'}}></div>
              <div className="w-1 h-1 bg-yellow-400 rounded-full animate-ping ml-8" style={{animationDelay: '1s'}}></div>
              <div className="w-1 h-1 bg-yellow-500 rounded-full animate-ping -ml-12" style={{animationDelay: '1.5s'}}></div>
            </div>
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">
            🎉 Success!
          </h1>
          <p className="text-blue-100 text-sm">
            Your password has been created successfully
          </p>
        </div>

        {/* Status Cards */}
        <div className="px-8 py-6 bg-green-50">
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white rounded-lg p-4 text-center shadow-sm">
              <FaShieldAlt className="text-green-500 text-xl mx-auto mb-2" />
              <p className="text-xs font-semibold text-gray-700">Password</p>
              <p className="text-xs text-green-600">Secured</p>
            </div>
            <div className="bg-white rounded-lg p-4 text-center shadow-sm">
              <FaLock className="text-green-500 text-xl mx-auto mb-2" />
              <p className="text-xs font-semibold text-gray-700">Account</p>
              <p className="text-xs text-green-600">Verified</p>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="px-8 py-8">
          {/* Success Message */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-green-100 rounded-full flex justify-center items-center mx-auto mb-4">
              <ImCheckmark className="text-green-500 text-2xl" />
            </div>
            <h2 className="text-xl font-bold text-gray-800 mb-3">
              Account Setup Complete!
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Your account has been successfully created and secured. You can now access all features of your patient portal.
            </p>
          </div>

          {/* Next Steps */}
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
              <span className="w-2 h-2 bg-primary100 rounded-full mr-2"></span>
              What's Next?
            </h4>
            <ul className="text-sm text-gray-600 space-y-2">
              <li className="flex items-start space-x-2">
                <ImCheckmark className="text-green-500 mt-1 text-xs" />
                <span>Access your medical records</span>
              </li>
              <li className="flex items-start space-x-2">
                <ImCheckmark className="text-green-500 mt-1 text-xs" />
                <span>Schedule appointments</span>
              </li>
              <li className="flex items-start space-x-2">
                <ImCheckmark className="text-green-500 mt-1 text-xs" />
                <span>View lab results</span>
              </li>
              <li className="flex items-start space-x-2">
                <ImCheckmark className="text-green-500 mt-1 text-xs" />
                <span>Communicate with healthcare providers</span>
              </li>
            </ul>
          </div>

          {/* Continue Button */}
          <button
            onClick={handleContinue}
            className="w-full bg-gradient-to-r from-primary100 to-blue-600 text-white py-4 rounded-lg font-semibold text-lg hover:from-blue-600 hover:to-primary100 transform hover:scale-[1.02] transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2"
          >
            <span>Continue to Dashboard</span>
            <FaArrowRight className="animate-pulse" />
          </button>

          {/* Security Note */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              🔒 Your data is encrypted and secure. Need help?{" "}
              <span className="text-primary100 hover:underline cursor-pointer">
                Contact support
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PasswordCorrect;
